import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import { SurveyStatus } from '../../../shared/utils/survey-status';

type BadgeColor = {
  background: string;
  foreground: string;
};

@Component({
  selector: 'ps-ui-survey-badge',
  template: `
    <div
      class="survey-badge"
      [ngStyle]="{
        'background-color': color.background,
        'border-color': color.foreground
      }"
    >
      <div
        class="dot"
        [ngStyle]="{ 'background-color': color.foreground }"
      ></div>
      <p class="status">{{ name }}</p>
    </div>
  `,
  styles: [
    `
      p {
        margin: 0;
        padding: 0;
        margin-left: 5px;
      }

      .survey-badge {
        display: inline-flex;
        align-items: center;
        border: 1px solid black;
        border-radius: 50px;
        padding: 2px 10px;
      }

      .dot {
        height: 10px;
        width: 10px;
        border-radius: 50%;
        background-color: black;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SurveyStatusBadgeComponent implements OnChanges {
  @Input()
  public status: number;

  public color: BadgeColor;
  public get name(): string {
    return SurveyStatus[this.status];
  }

  public ngOnChanges(): void {
    this.color = this._color();
  }

  private _color(): BadgeColor {
    switch (this.status) {
      case SurveyStatus.Draft:
        return { background: '#f1f2f4', foreground: '#9299ac' };
      case SurveyStatus.Live:
        return { background: '#e7f2e9', foreground: '#47e86a' };
      case SurveyStatus.Paused:
        return { background: '#f0f7fa', foreground: '#5b90c0' };
      case SurveyStatus.Closed:
        return { background: '#fbf6f8', foreground: '#e84787' };
      case SurveyStatus.Invoice:
        return { background: '#fbf9f6', foreground: '#f0cf3f' };
      default:
        return { background: 'white', foreground: 'white' };
    }
  }
}
